// mostly taken from here https://stackoverflow.com/questions/32968016/how-to-dynamically-load-reducers-for-code-splitting-in-a-redux-application
export default (store, createReducers) => {
  if (typeof createReducers !== "function") {
    throw new Error(
      `Expect second parameter to be of type function, not ${typeof createReducers}`,
    );
  }

  store.asyncReducers = {};

  store.injectAsyncReducer = (name, asyncReducer) => {
    if (store.asyncReducers[name]) {
      console.warn(
        `Tried to inject the reducer ${name}, but it already exists in the store.`,
      );
      return;
    }

    store.asyncReducers[name] = asyncReducer;

    store.replaceReducer(createReducers(store.asyncReducers));

    return store;
  };

  store.injectAsyncReducers = (reducers = []) => {
    if (reducers.length === 0) {
      throw new Error("Expects reducers to be of more than length 1");
    }

    reducers.forEach((reducerObj) => {
      const { name, reducer } = reducerObj;
      if (!name) {
        throw new Error(`Expects ${reducer} to be passed as an object with a name key`);
      }

      store.injectAsyncReducer(name, reducer);
    });

    return store;
  };

  store.removeAsyncReducer = (name) => {
    if (!store.asyncReducers[name]) {
      console.warn(
        `Tried to remove the reducer ${name}, but the reducer wasn't in the store`,
      );
      return;
    }

    delete store.asyncReducers[name];

    store.replaceReducer(createReducers(store.asyncReducers));

    return store;
  };

  store.removeAsyncReducers = (reducerNames = []) => {
    if (reducerNames.length < 1) {
      throw new Error("Expects an array of reducers");
    }

    reducerNames.forEach((name) => {
      store.removeAsyncReducer(name);
    });

    return store;
  };

  return store;
};
